import React from 'react';

const ClientTabs = ({ selectedTab, setSelectedTab, counts = {} }) => {
    const tabs = [
        { key: 'overview', label: '📊 Overview', count: null },
        { key: 'education', label: '🎓 Education', count: null },
        { key: 'experience', label: '💼 Experience', count: null },
        { key: 'languages', label: '🗣️ Languages', count: null },
        { key: 'family', label: '👨‍👩‍👧 Family', count: null },
        { key: 'financials', label: '💰 Financials', count: counts.invoices },
        { key: 'documents', label: '📁 Documents', count: counts.documents },
        { key: 'cases', label: '🗂️ Cases', count: counts.cases },
        { key: 'agreements', label: '📑 Agreements', count: counts.agreements },
        { key: 'timeline', label: '⏱️ Timeline', count: null }
    ];

    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="p-4">
                <div className="flex items-center gap-2 flex-wrap">
                    {tabs.map(tab => (
                        <button
                            key={tab.key}
                            onClick={() => {
                                setSelectedTab(tab.key);
                                try {
                                    localStorage.setItem('client_detail_tab', tab.key);
                                } catch (e) { }
                            }}
                            className={`px-4 py-2 rounded text-xs font-bold uppercase border transition-all ${selectedTab === tab.key
                                    ? 'bg-blue-600 text-white border-blue-500 shadow-lg shadow-blue-900/30'
                                    : 'bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600'
                                }`}
                        >
                            {tab.label}
                            {tab.count !== null && tab.count !== undefined && (
                                <span className="ml-2 px-1.5 py-0.5 rounded-full bg-gray-900 text-xs">
                                    {tab.count}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ClientTabs;
